import { lazy } from 'react';

export const AcceptInvitationPage = lazy(
  () => import('./AcceptInvitationPage')
);
